export default __webpack_public_path__ + "static/media/seo-illustration.b69d97bb.jpg";